import { createRouter, createWebHistory } from "vue-router";
import { getToken } from "@/utils/auth";
import Login from "../views/Login/Login.vue";

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    name: "status-statistics",
    path: "/status-statistics",
    component: () => import("../views/StatusStatistics/StatusStatistics.vue"),
  },
  {
    name: "status-statistics-date",
    path: "/status-statistics-date",
    component: () => import("../views/StatusStatistics/StatusStatisticsDate.vue"),
  },
  {
    path: "/crm",
    name: "Dashboard",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/Dashboard/Dashboard.vue"),
    children: [
      {
        name: "Chat",
        path: "/crm/chat",
        component: () => import("../components/Chat/Chat.vue"),
      },

      {
        name: "Charts",
        path: "/crm/panel",
        component: () => import("../views/Charts/Charts.vue"),
        meta: {
          breadcrumbs: [
            {
              name: "Charts",
            },
          ],
        },
      },
      {
        name: "Orders",
        path: "/crm/orders",
        component: () => import("../views/Orders/Orders.vue"),
        meta: {
          breadcrumbs: [
            {
              name: "Orders",
            },
          ],
        },
      },
      {
        name: "Order Statuses",
        path: "/crm/orders/statuses",
        component: () => import("../views/OrderStatuses/OrderStatuses.vue"),
        meta: {
          breadcrumbs: [
            {
              name: "Orders",
              to: "/crm/orders",
            },
            {
              name: "Order Statuses",
              to: "",
            },
          ],
        },
      },
      {
        name: "New order",
        path: "/crm/orders/new-order",
        component: () => import("../views/NewOrder/NewOrder.vue"),
      },
      {
        name: "Edit Order",
        path: "/crm/orders/edit-order/:id",
        component: () => import("../views/EditOrder/EditOrder.vue"),
      },
      {
        name: "Order details",
        path: "/crm/orders/order/:id",
        component: () => import("../views/OrderPage/OrderPage.vue"),
      },
      {
        name: "Products",
        path: "/crm/products",
        component: () => import("../views/Inventories/Inventories.vue"),
      },
      {
        name: "Preview Requests",
        path: "/crm/previews",
        component: () => import("../views/PreviewRequests/PreviewRequests.vue"),
      },
      {
        name: "New Preview Request",
        path: "/crm/new-preview-request",
        component: () => import("../views/NewPreviewRequest/NewPreviewRequest.vue"),
      },
      {
        name: "Sellers",
        path: "/crm/sellers",
        component: () => import("../views/Sellers/Sellers.vue"),
      },
      {
        name: "New Seller",
        path: "/crm/new-seller",
        component: () => import("../views/NewSeller/NewSeller.vue"),
      },
      {
        name: "Edit Seller",
        path: "/crm/edit-seller/:id",
        component: () => import("../views/EditSeller/EditSeller.vue"),
      },
      {
        name: "About Seller",
        path: "/crm/seller/:id",
        component: () => import("../views/AboutSeller/AboutSeller.vue"),
      },
      {
        name: "Tools",
        path: "/crm/tools",
        component: () => import("../views/Orders/Orders.vue"),
      },
      {
        name: "Reports",
        path: "/crm/reports",
        component: () => import("../views/Orders/Orders.vue"),
      },
      {
        path: "/crm/clock",
        component: () => import("../views/Orders/Orders.vue"),
      },
      {
        path: "/crm/settings",
        children: [
          {
            name: "Data Privacy",
            path: "/crm/settings/data-privacy",
            component: () => import("../views/DataPrivacy/DataPrivacy.vue"),
          },
          {
            name: "Exports History",
            path: "/crm/settings/data-privacy/export",
            component: () =>
              import("../views/DataPrivacyExportHistory/DataPrivacyExportHistory.vue"),
          },
        ],
      },
      {
        path: "/crm/upgrades",
        component: () => import("../views/Orders/Orders.vue"),
      },
      {
        name: "Production",
        path: "/crm/production",
        component: () => import("../views/Production/Production.vue"),
      },
      {
        name: "Laser Order",
        path: "/crm/laser-table/:id",
        component: () => import("../views/Laser/Laser.vue"),
      },
      {
        name: "Laser Orders",
        path: "/crm/laser-table",
        component: () => import("../views/Lasers/Lasers.vue"),
      },
      {
        name: "Binning",
        path: "/crm/binning",
        component: () => import("../views/Binning/Binning.vue"),
        meta: {
          breadcrumbs: [
            {
              name: "Binning",
            },
          ],
        },
      },
      {
        name: "Shipping",
        path: "/crm/shipping/:id",
        component: () => import("../views/Shipping/Shipping.vue"),
      },
      {
        name: "Shipped Bins",
        path: "/crm/shipped-bins",
        component: () => import("../views/ShippedBins/ShippedBins.vue"),
        meta: {
          breadcrumbs: [
            {
              name: "Binning",
              to: "/crm/binning",
            },
            {
              name: "Shipped Bins",
            },
          ],
        },
      },
      {
        name: "Cubby",
        path: "/crm/cubby",
        component: () => import("../views/Cubby/Cubby.vue"),
      },
      {
        name: "Stores",
        path: "/crm/stores",
        component: () => import("../views/Stores/Stores.vue"),
      },
      {
        name: "About Store",
        path: "/crm/store/:id",
        component: () => import("../views/AboutStore/AboutStore.vue"),
      },
      {
        name: "New Store",
        path: "/crm/store/new-store",
        component: () => import("../views/NewStore/NewStore.vue"),
      },
      {
        name: "Edit Store",
        path: "/crm/store/edit-store/:id",
        component: () => import("../views/NewStore/NewStore.vue"),
      },
      {
        name: "Gather Binning",
        path: "/crm/gather-binning/:id",
        component: () => import("../views/GatherBinning/GatherBinning.vue"),
      },
      {
        name: "Remake Order",
        path: "/crm/orders/remake-order/:id",
        component: () => import("../views/RemakeOrder/RemakeOrder.vue"),
      },
      {
        name: "Inventories",
        path: "/crm/inventories",
        component: () => import("../views/Inventories/Inventories.vue"),
        meta: {
          breadcrumbs: [
            {
              name: "Inventories",
            },
          ],
        },
        children: [
          {
            name: "Inventory",
            path: ":id",
            component: () => import("../views/Inventories/Inventory.vue"),
          },
        ],
      },
      {
        name: "Verify Order",
        path: "/crm/orders/verification/:id",
        component: () => import("../views/VerificationOrder/VerificationOrder.vue"),
        beforeEnter: (to, from) => {
          const isRedirected = from.name === "Order details" || from.name === "Orders";
          return isRedirected || { name: "Orders" };
        },
      },
    ],
    meta: {
      needsAuth: true,
    },
  },
  {
    path: "/icons",
    component: () => import("../components/UI/Iconography/IconsList/IconsList.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

const DEFAULT_TITLE = "HQ";

router.beforeEach((to) => {
  document.title = to.name || DEFAULT_TITLE;

  const isLoggedIn = !!getToken();
  // Replace, so the protected address does not stay in the history.
  if (to.meta.needsAuth && !isLoggedIn) return { path: "/", replace: true };
  return true;
});

export default router;
